import {Injectable} from '@angular/core';
import {environment} from '@env';

import {EMPTY, from, Observable} from 'rxjs';
import {ToastService} from '@app/service/util/toast.service';
import {share, tap} from 'rxjs/operators';
import {deleteToken, getMessaging, getToken, isSupported, onMessage} from '@angular/fire/messaging';
import {Database, ref, update} from '@angular/fire/database';
import {LoggerService} from '@app/service/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  isEnabled = false;
  token$: Observable<any> = EMPTY;
  message$: Observable<any> = EMPTY;

  constructor(private db: Database, private toastService: ToastService, private logger: LoggerService) {
  }

  async requestPermission(userId: string) {
    const _isSupported = await isSupported();
    if (_isSupported) {
      this.token$ = from(navigator.serviceWorker.register('firebase-messaging-sw.js', {
          type: 'module',
          scope: '__'
        }).then(serviceWorkerRegistration =>
          getToken(getMessaging(), {
            serviceWorkerRegistration,
            vapidKey: environment.vapidKey
          })
        )
      ).pipe(
        tap(token => {
          this.isEnabled = true;
          this.logger.log('SAVING TOKEN', token);
          const doc = ref(this.db, `users/${userId}`);
          return update(doc, {fcmToken: token});
        }),
        share()
      );
    }
  }

  async deleteToken() {
    const _isSupported = await isSupported();
    if (!this.isEnabled || !_isSupported) {
      return false;
    }
    return deleteToken(getMessaging());
  }

  async listen() {
    const _isSupported = await isSupported();
    if (!this.isEnabled || !_isSupported) {
      return false;
    }

    this.message$ = new Observable(sub => onMessage(getMessaging(), it => sub.next(it))).pipe(
      tap(message => {
        this.logger.log('MESSAGE FOR NOTIFICATION', message);
        const notification = message.notification;
        const data = message.data;
        this.toastService.response(data.type || 'info', notification.title, notification.body, data.duration);
      })
    );
    return;
  }
}
